<template>
  <div>
    <div :class="$style.box">
      <!-- 页面标题 -->
      <Title :name="name" :type="1"></Title>
      <!-- 个人信息 -->
      <div :class="$style.person">
        <div :class="$style['person-top']">
          <span>个人信息</span>
          <span @click="choose">重新选择</span>
          <span>领取条件</span>
          <img :src="question" @click="showTip" alt />
        </div>
        <div :class="$style['person-bot']">
          <div :class="$style['person-bot-left']">
            <p>
              游戏:
              <span>{{roleInfo.game}}</span>
            </p>
            <p>
              区服:
              <span>{{roleInfo.server_name}}</span>
            </p>
            <p>
              开服时间:
              <span>{{roleInfo.server_created_at}}</span>
            </p>
          </div>
          <div :class="$style['person-bot-right']">
            <p>
              开服天数:
              <span>{{changeTime(roleInfo.server_created_at) + "天"}}</span>
            </p>
            <p>
              角色:
              <span>{{roleInfo.role_name}}</span>
            </p>
            <p>
              角色等级:
              <span>{{roleInfo.turn_now + "转"}}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 红包领取 -->
      <div :class="$style.bag">
        <p>红包领取</p>
        <!-- 活动还未结束 -->
        <div :class="$style.content" v-if="activateFlag">
          <Packet
            :class="$style['content-box']"
            v-for="(item, index) in packetArr"
            :key="index"
            :title="item.title"
            :info="item.info"
            :turn="item.turn"
            :apply_status="item.apply_status"
            :packet_status="item.packet_status"
          ></Packet>
        </div>
        <!-- 活动已经结束 -->
        <p :class="$style.done" v-if="!activateFlag">活动已经结束，期待您下次参与！</p>
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from "@/config";
import { mapMutations, mapState, mapActions } from "vuex";
import Title from "@/components/Title.vue";
import Packet from "@/components/Packet.vue";

export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (!vm.roleInfo) vm.$router.push({ name: "role" });
    });
  },
  data() {
    return {
      name: "红包领取",
      question: `${CDN_URL}/packet/question.png`,
      bag: `${CDN_URL}/packet/packet.png`,
      bagOpen: `${CDN_URL}/packet/packet-open.png`,
      activateFlag: true,
      packetArr: [
        {
          key_name: "turn_4",
          turn: "turn_4",
          title: "4转红包",
          info: "10",
          apply_status: 0,
          packet_status: 0
        },
        {
          key_name: "turn_14",
          turn: "turn_14",
          title: "14转红包",
          info: "100",
          apply_status: 0,
          packet_status: 0
        },
        {
          key_name: "turn_21",
          turn: "turn_21",
          title: "20转红包",
          info: "1000",
          apply_status: 0,
          packet_status: 0
        },
        {
          key_name: "turn_25",
          turn: "turn_25",
          title: "25转红包",
          info: "华为P30PRO",
          apply_status: 0,
          packet_status: 0
        }
      ]
    };
  },
  components: {
    Title,
    Packet
  },
  computed: {
    ...mapState("packet", {
      roleInfo: "roleInfo"
    })
  },
  async mounted() {
    // 展示红包状态
    await this.showPacketStatus();
  },
  methods: {
    ...mapMutations("packet", {
      SHOW_TIP: "SHOW_TIP",
      HIDDEN_TIP: "HIDDEN_TIP",
      CLEAR_ROLEINFO: "CLEAR_ROLEINFO"
    }),
    ...mapActions("packet", {
      getPacketsStatus: "getPacketsStatus"
    }),
    showTip() {
      const tips = {
        tip_title: "领取条件",
        tip_info: [
          "*开服首日内游戏角色转生达到4转 10元现金； ",
          "*开服7天内游戏角色转生达到14转 100元现金；",
          "*开服15天内游戏角色转生达到21转 1000元现金；",
          "*开服30天内游戏角色转生达到25转 华为P30pro (256G)一台；"
        ]
      };
      this.SHOW_TIP(tips);
    },
    cutTime(time) {
      if (typeof time === "string") {
        return time.substr(0, time.indexOf(" "));
      }
      return time;
    },
    changeTime(time) {
      const old_date = new Date(time).getTime();
      const new_date = new Date().getTime();
      const day = new_date - old_date ;
      const days = Math.ceil(day / (1000 * 60 * 60 * 24));
      return days;
    },
    async showPacketStatus() {
      const r = await this.getPacketsStatus();
      this.packetArr.forEach((item, index) => {
        if (r.content[item.key_name]) {
          item = Object.assign(item, r.content[item.key_name]);
        }
      });
      console.log(this.packetArr)
    },
    choose() {
      this.CLEAR_ROLEINFO();
      this.$router.push({ name: "role" });
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  .person {
    width: 100%;
    height: 118px;
    // background-color: pink;
    padding: 10px 16px;
    .person-top {
      width: 100%;
      height: 18px;
      // background-color: yellow;
      position: relative;
      > span {
        position: absolute;
      }
      > span:nth-child(1) {
        font-size: 17px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 18px;
      }
      > span:nth-child(2) {
        width: 61px;
        height: 18px;
        background: rgba(255, 206, 100, 1);
        border-radius: 4px;
        font-size: 11px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 18px;
        text-align: center;
        left: 78px;
        top: 0;
      }
      > span:nth-child(3) {
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 18px;
        right: 22px;
        top: 0;
      }
      > img {
        width: 18px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .person-bot {
      width: 100%;
      height: 80px;
      // background-color: lightgreen;
      margin-top: 10px;
      .person-bot-left,
      .person-bot-right {
        width: 50%;
        height: 100%;
        // background-color: lightblue;
        float: left;
        padding: 0px 0px 0px 10px;
        > p {
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          > span {
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
          }
        }
      }
    }
  }
  .bag {
    width: 100%;
    height: 440px;
    // background-color: lightblue;
    margin-top: 33px;
    padding: 10px 16px;
    > p {
      font-size: 17px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 18px;
    }
    .content {
      width: 100%;
      height: 370px;
      // background-color: lightseagreen;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      .content-box {
        flex: none;
        margin: 0px 0px 0px 50px;
      }
    }
    .done {
      width: 100%;
      text-align: center;
      margin-top: 180px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>